import { render } from "./MbExternalTitle.vue?vue&type=template&id=fcd540e0&scoped=true"
import script from "./MbExternalTitle.vue?vue&type=script&lang=js"
export * from "./MbExternalTitle.vue?vue&type=script&lang=js"

import "./MbExternalTitle.vue?vue&type=style&index=0&id=fcd540e0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fcd540e0"

export default script